import type { DyTrackingParams } from './campaignEventData';

export type DyTrackingGA4Props = DyTrackingParams & {
  placement: string;
};

export const getDyTrackingGA4Params = (tracking?: DyTrackingGA4Props) => {
  if (tracking) {
    const { placement, ...rest } = tracking;

    return {
      type: placement,
      ...rest,
    };
  }

  return { type: '' };
};
